import {
    call,
    select,
    put,
    takeLatest,
} from 'redux-saga/effects';
import {
    getTourId,
} from '@shared/selector';
import actions from '@shared/actions';
import service from '@shared/service';

function * dataLoadSaga(action) {
    const tour_id = yield select(getTourId);
    let response;
    const password = action.payload && action.payload.password;
    yield put(actions.data.tour.updated({updated: [{id: tour_id, login: false}]}));
    try {
        response = yield call(service.loadTour, {tour_id, password});
    } catch (error) {
        return;
    }
    if (response.status === 'success') {
        if (response.data.tour) {
            yield put(actions.data.tour.updated({updated: [response.data.tour]}));
        }
        if (response.data.floors) {
            yield put(actions.data.floor.updated({updated: response.data.floors}));
        }
        if (response.data.rooms) {
            yield put(actions.data.room.updated({updated: response.data.rooms}));
        }
        if (response.data.infopoints) {
            yield put(actions.data.infopoint.updated({updated: response.data.infopoints}));
        }
        if (response.data.floorplan_points) {
            yield put(actions.data.floorplan_infopoint.updated({updated: response.data.floorplan_points}));
        }
        if (response.data.customer) {
            yield put(actions.data.customer.updated({updated: [response.data.customer]}));
        }
        if (response.data.global) {
            yield put(actions.data.global.updated({
                base_url: response.data.global.base_url,
                base_url_embed: response.data.global.embed_url,
            }));
        }
    }
}

export default function * actionWatcher() {
    yield takeLatest(actions.data.load.type, dataLoadSaga);
}

